<template>
  <div class="app">
    <router-view :language="language" :t="t" :handleLang="handleLang" />
  </div>
</template>

<script>
import TranslationService from "@/services/TranslationService.js";

export default {
  name: "app",

  data: () => ({
    language: "pl"
  }),

  methods: {
    t(key) {
      return TranslationService.translate(key, this.language);
    },
    handleLang(lang) {
      return (this.language = lang);
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap&subset=latin-ext");
@import "reset-css";

*,
*::before,
*::after {
  box-sizing: border-box;
}

.app {
  overflow: hidden;

  max-width: 1440px;
  margin: 0 auto;

  font-family: "Roboto", Helvetica, Arial, sans-serif;
  color: #120f0f;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes sharpen {
  0% {
    filter: blur(3px);
  }

  100% {
    filter: blur(0);
  }
}
</style>
